/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import { useTheme } from '@coursera/cds-core';

import type {
  EntWebsiteBlockPdfViewerQuery,
  EntWebsitePdfViewerFragment,
} from 'bundles/ent-website/__generated__/contentfulTypes';
import PdfViewer from 'bundles/ent-website/components/PdfViewer';
import BlockLayout from 'bundles/ent-website/contentful/core/BlockLayout';
import { entWebsiteBlockPdfViewerQuery } from 'bundles/ent-website/queries/EntWebsitePdfViewer';
import withBlockQuery from 'bundles/ent-website/utils/withBlockQuery';
import type { BlockModuleInnerProps } from 'bundles/ent-website/utils/withBlockQuery';

type Props = BlockModuleInnerProps<EntWebsitePdfViewerFragment>;

export function PdfViewerModule({ content, assembly }: Props) {
  const theme = useTheme();
  const styles = {
    error: css`
      background-color: ${theme.palette.red[100]};
      color: ${theme.palette.white};
      font-size: 24px;
      padding: ${theme.spacing(16)};
    `,
  };
  const pdfUrl = content.fileAttachment?.url;

  const contentPanel = () => {
    if (!pdfUrl) {
      return <div css={styles.error}>No PDF file found</div>;
    }

    return <div>{Boolean(pdfUrl) && <PdfViewer url={pdfUrl} />}</div>;
  };

  return <BlockLayout assembly={assembly} renderContent={contentPanel} />;
}

// @ts-expect-error TSMIGRATION-5.0 TS2344
export const BlockPdfViewer = withBlockQuery<EntWebsitePdfViewerFragment, EntWebsiteBlockPdfViewerQuery>(
  entWebsiteBlockPdfViewerQuery
)(PdfViewerModule);
